function DisableDeliveryZoneModalController(
    $scope,
    $uibModalInstance,
    PermissionService,
    zones,
    moment
) {
    this.modalInstance = $uibModalInstance;
    this.permissionService = PermissionService;
    this.user = this.permissionService.user;
    this.zones = zones;

    this.isOneZone = this.zones.length === 1;
    this.alwaysDate = moment('2199-01-01');


    $scope.intervalOptions = {
        "Always": {
            label: 'Always',
        },
        "15min": {
            label: '15 minutes',
            hours: 0,
            minutes: 15
        },
        "30min": {
            label: '30 minutes',
            hours: 0,
            minutes: 30
        },
        "1": {
            label: '1 hour',
            hours: 1,
            minutes: 0
        },
        "2": {
            label: '2 hours',
            hours: 2,
            minutes: 0
        },
        "4": {
            label: '4 hours',
            hours: 4,
            minutes: 0
        },
        "8": {
            label: '8 hours',
            hours: 8,
            minutes: 0
        },
        "12": {
            label: '12 hours',
            hours: 12,
            minutes: 0
        },
        "24": {
            label: '24 hours',
            hours: 24,
            minutes: 0
        }
    }

    $scope.timeInterval = $scope.intervalOptions.Always;

    $scope.intervalOptionsKeys = () => Object.keys($scope.intervalOptions)
        .sort((a, b) => {
            if (a === 'Always') {
                return -1;
            }
            if (b === 'Always') {
                return 1;
            }
            if (a === '15min') {
                return -1;
            }
            if (b === '15min') {
                return 1;
            }
            if (a === '30min') {
                return -1;
            }
            if (b === '30min') {
                return 1;
            }
        });

    $scope.cancel = () => {
        if(this.isOneZone) {
            this.zones[0].IsEnabled = true;
        }
        this.modalInstance.close();
    };

    $scope.ok = () => {
        this.zones.forEach((zone) => {
            if((!this.isOneZone
                && zone.IsExclusion)
                || this.alwaysDate.isBefore(zone.DisabledUntil)) {
                return;
            }
            zone.IsEnabled = false;
            setDisabledUntil(zone);
            zone.UserFullName = `${this.user.FirstName} ${this.user.LastName}`;
        });
        this.modalInstance.close();
    };

    function setDisabledUntil(zone) {
        if($scope.timeInterval.label === "Always") {
            zone.DisabledUntil = new moment('2200-01-01');
        } else {
            zone.DisabledUntil = new moment()
                .add($scope.timeInterval.hours, 'Hours')
                .add($scope.timeInterval.minutes, 'Minutes');
        }
    }

    $scope.zoneName = () => {
        return this.isOneZone
            ? `the ${this.zones[0].Name} delivery zone`
            : "all delivery zones"
    }
}

angular.module('dashboard')
    .controller('DisableDeliveryZoneModalController',
        [
            '$scope',
            '$uibModalInstance',
            'PermissionService',
            'zones',
            'moment',
            DisableDeliveryZoneModalController
        ])


